export default {
    APP_ENV: "PROD",
    // DEV_URL: 'https://walletserver.greenlighttrust.com/devwalletservice',
    DEV_URL: 'http://44.213.171.19:5010',
    
    PROD_URL: 'https://walletserver.greenlighttrust.com/walletservice'
}